import { Action, Dispatch } from 'redux'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { db, FirebaseDocumentDataType } from 'firebase/index'
import { dateToString } from 'lib/helper'
import { fetchOrdersAction } from 'reducks/checkout/actions'
import { mergeCheckoutItems, mergeCheckoutWithItems } from 'reducks/checkout/operations'

const fetchOrderGroup = (startDate: Date, endDate: Date) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
    const snapshots: FirebaseDocumentDataType = await db
      .collectionGroup('store_checkouts')
      .orderBy('date', 'asc')
      .startAt(dateToString(startDate))
      .endAt(dateToString(endDate))
      .get()
    const items = await mergeCheckoutItems(snapshots, [])
    const orders = mergeCheckoutWithItems(snapshots, items)
    orders.sort((a, b) => {
      if (!a.checkout_at || !b.checkout_at) {
        return a.updated_at > b.updated_at ? -1 : 1
      } else {
        return a.checkout_at > b.checkout_at ? -1 : 1
      }
    })
    dispatch(fetchOrdersAction(orders))
    dispatch(hideLoadingAction())
  }
}

export default fetchOrderGroup
